module.exports = __webpack_public_path__ + "static/media/hp.712a1734.png";